import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import {Tab, Tabs} from '@jetbrains/ring-ui/components/tabs/tabs'
import * as React from 'react'
import {useCallback, useState, Suspense} from 'react'

import useDocumentTitle from '../../../hooks/useDocumentTitle'
import type {TestId} from '../../../types'
import {ROOT_PROJECT_ID} from '../../../types'
import BuildProblemList from '../../packages/Problems/BuildProblems/BuildProblemList/BuildProblemList'
import BuildTypeProblemList from '../../packages/Problems/BuildTypeProblems/BuildTypeProblemList/BuildTypeProblemList'
import {
  BUILD_CONFIGURATION_PROBLEMS_TAB_LABEL,
  BUILD_PROBLEMS_TAB_LABEL,
  Problems,
  TESTS_TAB_LABEL,
} from '../../packages/Problems/Problems.types'
import TestProblemList from '../../packages/Problems/TestProblems/TestProblemList/TestProblemList'

import InvestigationFilters from './InvestigationFilters/InvestigationFilters'
import {useProjectIdFilter} from './InvestigationFilters/InvestigationFilters.hooks'
import {useInvestigationTab} from './InvestigationsPage.hooks'

import styles from './InvestigationsPage.css'

function InvestigationsPage() {
  useDocumentTitle(`My investigations - TeamCity`)

  const {investigationsTab, onSelect} = useInvestigationTab()

  const filter = useProjectIdFilter()
  const projectId = filter.projectId ?? ROOT_PROJECT_ID

  const [selectedIds, setSelectedIds] = useState<TestId[]>([])

  const onSelectedIdsChange = useCallback((ids: TestId[]) => {
    setSelectedIds(ids)
  }, [])

  const onClearSelection = useCallback(() => {
    setSelectedIds([])
  }, [])

  return (
    <div className={styles.page}>
      <H1>{'My investigations'}</H1>

      <Tabs selected={investigationsTab} onSelect={onSelect}>
        <Tab id={Problems.TESTS} title={TESTS_TAB_LABEL}>
          <InvestigationFilters withGrouping withMuteFilter onChange={onClearSelection} />
          <Suspense>
            <TestProblemList
              projectId={projectId}
              onlyInvestigated
              selectedIds={selectedIds}
              onSelectedIdsChange={onSelectedIdsChange}
            />
          </Suspense>
        </Tab>
        <Tab disabled id={Problems.BUILD_PROBLEMS} title={BUILD_PROBLEMS_TAB_LABEL}>
          <InvestigationFilters withMuteFilter />
          <BuildProblemList projectId={projectId} />
        </Tab>
        <Tab
          disabled
          id={Problems.BUILD_CONFIGURATION_PROBLEMS}
          title={BUILD_CONFIGURATION_PROBLEMS_TAB_LABEL}
        >
          <InvestigationFilters />
          <BuildTypeProblemList projectId={projectId} />
        </Tab>
      </Tabs>
    </div>
  )
}

export default React.memo<{}>(InvestigationsPage)
